class ToastClass {
  constructor() {}
  success(message, timeInMlls) {
    let toastEle = document.getElementById("saber-toast-01");
    let toastEleMiddle = document.getElementById("saber-toast-01-middle");
    toastEleMiddle.innerHTML = ` <span class="text-[green] text-[20px] ">&#x2713;</span>
    <h2 id="saber-toast-01-message" class="text-[#555] text-[18px] ">
      ${message}
    </h2>`;
    toastEle.classList.remove("toast-style-main-component-out");
    toastEle.classList.add("toast-style-main-component-in");

    setTimeout(
      () => {
        toastEle.classList.remove("toast-style-main-component-in");
        toastEle.classList.add("toast-style-main-component-out");
      },
      timeInMlls ? timeInMlls + 500 : 2500
    );

    setTimeout(
      () => {
        toastEleMiddle.innerHTML = "";
      },
      timeInMlls ? timeInMlls + 750 : 3750
    );
  }

  failed(message, timeInMlls) {
    let toastEle = document.getElementById("saber-toast-01");
    let toastEleMiddle = document.getElementById("saber-toast-01-middle");
    toastEleMiddle.innerHTML = ` <span class="text-[#D9232E] text-[20px] ">&#10006;</span>
    <h2 id="saber-toast-01-message" class="text-[#555] text-[18px] ">
      ${message}
    </h2>`;
    toastEle.classList.remove("toast-style-main-component-out");
    toastEle.classList.add("toast-style-main-component-in");

    setTimeout(
      () => {
        toastEle.classList.remove("toast-style-main-component-in");
        toastEle.classList.add("toast-style-main-component-out");
      },
      timeInMlls ? timeInMlls + 500 : 2500
    );

    setTimeout(
      () => {
        toastEleMiddle.innerHTML = "";
      },
      timeInMlls ? timeInMlls + 750 : 3750
    );
  }

  closeImmediate() {
    let toastEle = document.getElementById("saber-toast-01");
    let toastEleMiddle = document.getElementById("saber-toast-01-middle");
    toastEle.classList.remove("toast-style-main-component-in");
    toastEle.classList.add("toast-style-main-component-out");
    setTimeout(() => {
      toastEleMiddle.innerHTML = "";
    }, 250);
  }
}

export default ToastClass;
